<template>
  <div style="padding-top: 100px;">
    <!-- 設定大頭貼 -->
    <el-dialog title="系統通知" :visible.sync="dialogMsg">
      <span>{{ result }}</span>
    </el-dialog>
    <el-dialog title="系統通知" :visible="openSuccess" :show-close="false">
      <div style="margin-top: -20px; text-align: left;"><h3>您的 Webhook 網址:</h3></div>
      <el-input v-model="webhook"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" style="margin-top: -20px;" @click="connectUser">完成設定</el-button>
      </span>
    </el-dialog>
    <!-- 綁定 LINE -->
    <el-dialog title="綁定帳號" :visible.sync="openLine" :close-on-click-modal="false">
      <el-input placeholder="請输入品牌名稱" style="width: 90%; margin-bottom: 10px;" v-model="provider">
        <template slot="prepend">App Name</template>
      </el-input>
      <br><br>
      <el-input placeholder="請输入 Channel ID" style="width: 90%; margin-bottom: 10px;" v-model="channelid">
        <template slot="prepend">Channel ID</template>
      </el-input>
      <br><br>
      <el-input placeholder="請输入 Basic ID" style="width: 90%; margin-bottom: 10px;" v-model="basic">
        <template slot="prepend">Basic ID</template>
      </el-input>
      <br><br>
      <el-input placeholder="請输入 Access Token" style="width: 90%; margin-bottom: 10px;" v-model="token">
        <template slot="prepend">Access Token</template>
      </el-input>
      <br>
      <div style="color: #f24">{{hintMsg}}</div>
      <br>
      <el-button type="success" @click="generateWebhook">取得 webhook</el-button>
    </el-dialog>
    <!-- 綁定 LINE -->
    <div v-if="showMsg">
      <!-- <el-button style="position: absolute; right: 20px; top: 20px; font-size: 18px; font-weight: 500; width: 80px" type="danger" plain size="small" @click="logout">登出</el-button> -->
      <div class="service">
        <el-row style="max-width: 1200px; margin: 0 auto;">
          <!-- 臉書登入 -->
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin-bottom: 20px;">
            <div class="bg-purple">
              <el-row :gutter="10">
                <el-col :span="5">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Facebook_Messenger_logo.svg/1015px-Facebook_Messenger_logo.svg.png" width="70"/>
                </el-col>
                <el-col :span="18">
                  <h1 style="font-size: 35px;">EILIS FB</h1>
                </el-col>
              </el-row><br/>

              <div v-if="loginAlready">
                <el-row :gutter="10">
                  <el-col :span="14">
                    <el-select v-model="choosePage" placeholder="請選擇粉專" style="width: 100%;">
                      <el-option v-for="(item, idx) in options2"
                        :key="idx"
                        :label="item.PageName"
                        :value="JSON.stringify(item)">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="10">
                    <el-button size="medium" type="info" style="height: 40px;" @click="openPageDia = true">新增</el-button>
                  </el-col>
                </el-row>
              </div>

              <div style="position: absolute; bottom: 20px; right: 20px;">
                <el-button v-if="!FBUser" size="medium" type="primary" @click="loginFB">臉書登入</el-button>
                <el-button v-if="FBUser" size="medium" type="primary" @click="loginFB">重新登入</el-button>
                <el-button v-if="loginAlready" size="medium" type="primary" :disabled="!choosePage">前往設定</el-button>
              </div>

              <div style="position: absolute; bottom: 18px; left: 20px;">
                <mu-avatar :size="50">
                  <mu-icon v-if="!FBPhoto || FBPhoto === ''" value="account_circle" size="40"></mu-icon>
                  <img v-if="FBPhoto && FBPhoto !== ''" :src="FBPhoto">
                </mu-avatar>
                <div style="line-height: 20px; display: inline-block; margin-left: 10px;">已登入: <span style="font-weight: 500;">{{ fbName }}</span></div>
              </div>

              <mu-dialog title="粉專列表" width="60%" max-width="650" :open="openPageDia" scrollable>
                <el-row :gutter="20">

                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <h5 style="margin-top: 10px; opacity: 0.8;">管理員</h5>
                    <el-checkbox-group v-model="selectedPage">
                      <el-checkbox v-for="(item, index) in AdminPage" :key="index" :label="JSON.stringify(item)" border style="width: 100%; margin-bottom: 10px; margin-left: 0; overflow: hidden; text-overflow : ellipsis;" :disabled="item.Status === 'Enabled'">{{ item.PageName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-col>

                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <h5 style="margin-top: 10px; opacity: 0.8;">編輯者</h5>
                    <el-checkbox-group v-model="selectedPage">
                      <el-checkbox v-for="(item, index) in EditPage" :key="index" :label="JSON.stringify(item)" border style="width: 100%; margin-bottom: 10px; margin-left: 0; overflow: hidden; text-overflow : ellipsis;" :disabled="item.Status === 'Enabled'">{{ item.PageName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                </el-row>
                <mu-button slot="actions" flat color="primary" @click="closePageDia">返回</mu-button>
                <mu-button slot="actions" color="primary" @click="checkOpen" :disabled="selectedPage.length < 1">開通</mu-button>
              </mu-dialog>

              <mu-dialog title="確認訊息" width="60%" max-width="650" :open="doubleCheck">
                再次確認要開通的粉專:
                <el-tag v-for="tag in selectedName" :key="tag" type="primary" style="margin-left: 10px;">
                  {{ tag }}
                </el-tag>
                <div style="margin-top: 10px;">開通後你將成為粉專機器人主管理員，若有他人想設定必須由主管理員開放權限。</div>

                <mu-button slot="actions" flat color="primary" @click="doubleCheck = false">重新選擇</mu-button>
                <mu-button slot="actions" color="primary" @click="enableFBPage">確認</mu-button>
              </mu-dialog>
            </div>
          </el-col> -->
          <!-- LINE 登入 -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="bg-purple">
              <el-row :gutter="10">
                <el-col :span="5">
                  <img src="https://is3-ssl.mzstatic.com/image/thumb/Purple118/v4/d4/8a/dd/d48addb0-bd27-5687-a8ae-1276c3e1d31f/LINE.png/1200x630bb.png" width="80"/>
                </el-col>
                <el-col :span="18">
                  <h1 style="font-size: 35px;">EILIS LINE</h1>
                </el-col>
              </el-row><br/>
              <div v-if="registered">
                <el-row>
                  <el-col :span="14">
                    <el-select @change="getID" v-model="value" placeholder="請選擇帳號" style="width: 90%;">
                      <el-option v-for="(item, idx) in options"
                        :key="idx"
                        :label="item.Provider"
                        :value="JSON.stringify(item)">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="10">
                    <div style="margin-top:10px;" v-if="paymentStatus === '未付款'">付款狀態: <span style="font-weight: 600; opacity: 0.7;">未付款</span><a href="#" style="margin-left: 7px; color: #f24;">前往付款</a></div>
                    <div style="margin-top:10px;" v-if="paymentStatus === '已付款'">付款狀態: <span style="font-weight: 600;">已付款</span><i style="font-size: 16px; color: #28c122; margin-left: 5px;" class="el-icon-success"></i></div>
                  </el-col>
                </el-row>
              </div>
              <div style="position: absolute; bottom: 20px; right: 20px;">
                <el-button v-if="!registered" @click="openLine = true; hintMsg = ''" size="medium" type="success">註冊 EILIS</el-button>
                <div v-if="registered">
                  <el-button size="medium" type="success"  @click="openLine = true">註冊新帳號</el-button>
                  <el-button v-if="paymentStatus === '已付款'" size="medium" type="success"  @click="goSetting" :disabled="paymentStatus === '未付款' || !value">設定頁面</el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'mainPage',
  data() {
    return {
      Name: '',
      lastLogin: '',
      dialogMsg: false,
      showMsg: false,
      // FB
      loginBtn: false,
      result: '驗證身分中...',
      showFB: false,
      FBUser: false,
      FBPhoto: '',
      fbName: '無',
      loginAlready: false,
      openPageDia: false,
      doubleCheck: false,
      usablePage: [],
      selectedPage: [],
      // LINE
      openLine: false,
      channelid: '',
      token: '',
      registered: false,
      webhook: '',
      openSuccess: false,
      provider: '',
      loading2: true,
      value: '',
      basic: '',
      choosePage: '',
      value2: {},
      options: [],
      options2: [],
      hintMsg: '',
      paymentStatus: '',
      value3: 0,
    };
  },
  mounted() {
    this.dialogMsg = true;
    // 檢查登入狀態
    this.checkLoginStatus();
  },
  computed: {
    AdminPage() {
      return this.usablePage.filter(el => el.Tasks.indexOf('MANAGE') !== -1);
    },
    EditPage() {
      return this.usablePage.filter(el => el.Tasks.indexOf('MANAGE') === -1);
    },
    selectedName() {
      const usabledData = this.selectedPage.map(el => JSON.parse(el));
      return usabledData.map(el => el.PageName);
    }
  },
  methods: {
    // 資料存進 DB
    // saveData(user, uid) {
    //   const apiUrl = 'https://api-dashboard.eilis-ai.com/users/FBLogin';
    //   const postData = {
    //     UserID: uid,
    //     FBID: user.UserID,
    //     FBName: user.UserName
    //   };
    //   this.axios.post(apiUrl, postData)
    //     .then(() => {
    //       alert('綁定帳號成功');
    //     });
    // },
    // openUrl() {
    //   const linkUrl = window.parent.location.href;
    //   location.href = `https://api-eilis-server2.herokuapp.com/functional/loginUser?Redirect=${linkUrl}`;
    // },
    logout() {
      localStorage.clear();
      window.location.reload();
    },
    // loginFB() {
    //   location.href = 'https://api-dashboard.eilis-ai.com/auth/facebook/callback';
    // },
    // closePageDia() {
    //   this.openPageDia = false;
    //   this.selectedPage = [];
    // },
    // enableFBPage() {
    //   this.doubleCheck = false;
    //   this.openPageDia = false;
    //   const userid = localStorage.getItem('FBID');
    //   const uid = localStorage.getItem('UserID');
    //   const username = localStorage.getItem('UserName');
    //   const pageList = this.selectedPage.map(el => JSON.parse(el));
    //   const apiUrl = 'https://api-dashboard.eilis-ai.com/users/addPageToAdmin';
    //   const postData = {
    //     UID: uid,
    //     UserID: userid,
    //     UserName: username,
    //     PageList: pageList
    //   };
    //   this.axios.post(apiUrl, postData).then(() => {
    //     window.location.reload();
    //   });
    // },
    // checkOpen() {
    //   this.doubleCheck = true;
    // },
    checkService() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const apiUrl = 'https://api-dashboard.eilis-ai.com/users/checkUser';
      const uid = localStorage.getItem('UserID');
      this.axios.post(apiUrl, {
        uid: uid
      }).then((res) => {
        loading.close();
        if (res.data && res.data.line) {
          this.options = Object.values(res.data.line);
          this.registered = true;
        }
        if (res.data && res.data.fb) {
          this.options2 =  Object.values(res.data.fb);
        }
      });
    },
    getID(val) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.value2 = JSON.parse(val);
      const data = JSON.parse(val);
      const apiUrl = 'https://api-dashboard.eilis-ai.com/users/getChannelDetail';

      this.axios.post(apiUrl, { ChannelID: data.ChannelID })
        .then((res) => {
          loading.close();
          this.value2.AccessToken = res.data.AccessToken;
          this.value2.ClientName = res.data.Admin;
          if (res.data.PaymentStatus === 'Not Paid') {
            this.paymentStatus = '未付款';
          }
          else {
            this.paymentStatus = '已付款';
          }
        });
    },
    getUserFBData(userid) {
      const apiUrl = 'https://api-dashboard.eilis-ai.com/users/getUserFBData';
      this.axios.post(apiUrl, { UserID: userid }).then((res) => {
        const userDetail = res.data.Detail;
        this.FBPhoto = userDetail.Picture;
        this.fbName = userDetail.UserName;
        this.usablePage = Object.values(userDetail.PageList);
        this.loginAlready = true;
        this.FBUser = true;
      });
    },
    checkLoginStatus() {
      if (localStorage.getItem('UserID') && localStorage.getItem('lastLogin') && localStorage.getItem('UserName')) {
        this.loginBtn = false;
        this.Name = localStorage.getItem('UserName');
        this.lastLogin = `${new Date(parseInt(localStorage.getItem('lastLogin'))).toLocaleString()}`;
        this.showMsg = true;
        this.dialogMsg = false;
        // 取得用戶詳細資訊
        this.getUserDetail();
        // 確定用戶服務
        this.checkService();
        if (this.$route.query.status === 'FB_LOGIN_SUCCESS') {
          const fbid = this.$route.query.UserID.replace('#_=_', '');
          this.getUserFBData(fbid);
          localStorage.setItem('FBID', fbid);
          this.$router.push('/chatbot');
        }
        if (localStorage.getItem('FBID')) {
          const fbid = localStorage.getItem('FBID');
          this.getUserFBData(fbid);
        }
      } else {
        this.$router.push('/');
      }
    },
    // 取得 webhook
    generateWebhook() {
      if (this.channelid && this.token && this.provider && this.basic) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // 取得 Webhook 使用
        const apiUrl = 'https://tc-line-bot.herokuapp.com/app/Install/Eilis';
        const apiUrl2 = 'https://api-dashboard.eilis-ai.com/users/getService';
        const postData = {
          ClientName: this.channelid,
          ChannelAccessToken: this.token,
          BasicID: this.basic
        };
        // 優先檢查帳戶是否存在
        const postData2 = {
          ChannelID: this.channelid,
          Service: 'line',
          Admin: localStorage.getItem('UserName'),
          AdminID: localStorage.getItem('UserID'),
          AccessToken: this.token,
          ChannelName: this.provider,
          BasicID: this.basic,
          Plan: 'Beta 測試版',
          RegisterTime: new Date().toLocaleString()
        };
        this.axios.post(apiUrl2, postData2)
          .then((res) => {
            if (res.data && res.data.Message === '成功加入資料庫') {
              this.hintMsg = '';
              this.axios.post(apiUrl, postData)
                .then((res) => {
                  this.webhook = res.data.webhook;
                  this.openLine = false;
                  this.openSuccess = true;
                  loading.close();
                });
            } else {
              loading.close();
              this.hintMsg = res.data.Message;
            }
          });
      } else {
        this.hintMsg = '有資料漏填';
      }
    },
    // 完成設定
    connectUser() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const apiUrl = 'https://api-dashboard.eilis-ai.com/users/LineUser';
      const postData = {
        UserID: localStorage.getItem('UserID'),
        ChannelID: this.channelid,
        ChannelName: this.provider,
        BasicID: this.basic,
        Token: this.token,
        Charater: 'Admin'
      };
      this.axios.post(apiUrl, postData)
        .then((res) => {
          loading.close();
          window.location.reload();
        });
    },
    getProvider(val) {
      this.provider = val;
    },
    goSetting() {
      window.open(`http://linebiz.eilis-ai.com/?ChannelID=${this.value2.ChannelID}&ChannelName=${this.value2.Provider}&UserName=${localStorage.getItem('UserName')}&AccessToken=${this.value2.AccessToken}&uid=${localStorage.getItem('UserID')}`);
    },
    getUserDetail() {
      const apiUrl = 'https://api-dashboard.eilis-ai.com/users/getUserDetail';
      const postData = {
        uid: localStorage.getItem('UserID')
      };
      this.axios.post(apiUrl, postData)
        .then((res) => {
          localStorage.setItem('MemberData', JSON.stringify(res.data.detail));
          // 取得大頭照
          if (res.data.detail.ProfileImg) {
            localStorage.setItem('ProfileImg', res.data.detail.ProfileImg);
          }
        });
    }
  },
}
</script>

<style>
.upload {
  display: block;
  width: 90px;
  color: #777;
  line-height: 28px;
  font-size: 15px;
  text-align: center;
  border-radius: 3px;
  margin: 0 auto;
  cursor: pointer;
  background: #fff;
  border: 1px solid #777;
  transition: 0.2s;
}
.upload:hover {
  background: #777;
  color: #fff;
}
#myFile {
  display: none;
}
.profilePhoto {
  cursor: pointer;
  transition: 0.3s;
}

.profilePhoto:hover {
  opacity: 0.8;
}

.upload-demo {
  text-align: left;
}
.el-upload__tip {
  margin-left: 10px;
}
.mu-appbar-title {
  text-align: left;
}
.bg {
  padding: 0;
  text-align: center;
}
.FB {
  position: absolute;
  top: 45%;
  left: 10%;
}
.photo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: inline-block;
}
.title {
  position: absolute;
  left: 110px;
  font-size: 30px;
}
.img {
  position: absolute;
  top: 15px;
  left: 15px;
}
.service {
  text-align: center;
  padding: 10px;
}
.bg-purple {
  margin: 0 auto;
  text-align: left;
  position: relative;
  min-width: 450px;
  max-width: 500px;
  width: 90%;
  padding: 20px;
  min-height: 320px;
  background-color: #fff;
  transition: 0.3s;
  border-radius: 10px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.bg-purple:hover {
  transform: scale(1.05);
}
.grid-content {
  position: relative;
  text-align: left;
  margin: 10px auto;
  width: 70%;
  border-radius: 4px;
  min-height: 300px;
}
.el-input-group__prepend {
  width: 140px;
  background-color: #777;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
}
.selector {
  position: absolute;
  top: 130px;
  left: 20px;
}
</style>